import { render, staticRenderFns } from "./ChangePassword.pug?vue&type=template&id=9914d4e4&scoped=true&lang=pug&"
import script from "./ChangePassword.vue?vue&type=script&lang=js&"
export * from "./ChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./ChangePassword.scss?vue&type=style&index=0&id=9914d4e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9914d4e4",
  null
  
)

export default component.exports